<template>
	<bernstein-layout>
		<template #header>
			<h2 class="text-xl font-semibold leading-tight text-gray-800">
				Dashboard
			</h2>
		</template>
		<div
			class="border-3 mx-2 my-4 flex flex-col border border-blue-600 bg-gray-50 px-6 py-4 shadow-md"
		>
			<div class="mx-auto p-2">
				Vielen Dank!! Wir haben die Transportliste versendet.<br />
				<!-- listname: {{ transportFilename }} -->
				<!-- {{ transportList }} -->
				<a :href="transportFilename"> Download Trasnsport List </a>
			</div>
			<div v-if="transportList">
				<!-- <p>Email: {{ transportList["email_list"] }}}</p> -->
				<table>
					<thead>
						<tr>
							<th>ItemId</th>
							<th>VariationId</th>
							<th>Name</th>
							<th>Main Warehouse</th>
							<th>From</th>
							<th>To</th>
							<th>Quantity</th>
						</tr>
					</thead>
					<tbody>
						<tr
							v-for="(listKey, kIndx) in transportList"
							:key="kIndx"
							class="my-2 py-2"
						>
							<td>
								{{ transportList["itemId"] }}
							</td>
							<td>
								{{ transportList["variationId"] }}
							</td>
							<td>
								{{ transportList["name"] }}
							</td>
							<td>
								{{ transportList["main_warehouse"] }}
							</td>
							<!-- from ware house  -->
							<!-- @change="$emit('update_from_warehouse', $event.target.value)" -->
							<td>
								{{ transportList["from_warehouse"] }}
							</td>
							<!-- To warehouse  -->
							<td>
								{{ transportList["to_warehouse"] }}
							</td>

							<!-- from warehosue stock number  -->
							<td>
								{{ transportList["from_stock"] }}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</bernstein-layout>
</template>
<script>
import BernsteinLayout from "@/Layouts/BernsteinLayout.vue";
import BernsteinDashboard from "@/Bernstein/BernsteinDashboard.vue";
import { toRefs, toRef } from "vue";
import { useForm } from "@inertiajs/inertia-vue3";
import JetLabel from "@/Jetstream/Label.vue";
import JetInput from "@/Jetstream/Input.vue";

import JetButton from "@/Jetstream/Button.vue";
export default {
	components: {
		BernsteinLayout,
		BernsteinDashboard,
		JetLabel,
		JetInput,
		JetButton,
	},

	props: {
		transportList: Object,
		transportFilename: String,
		// list_row: [],
	},
};
</script>
